/* eslint-disable import/prefer-default-export */
import { STORAGE_KEY } from './constants'

export function persistedConsent() {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (raw) {
    return JSON.parse(raw)
  }
  return undefined
}
